<!-- =========================================================================================
    File Name: TechnicItem.vue
    Description: Single technic item component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div @click="displayPrompt" class="px-4 list-item-component">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-10/12 flex sm:items-center sm:flex-row flex-col">
        <div class="flex items-center" :class="setClasses('mobSatir', 'tekSatir')">
          <!-- <vs-checkbox v-model="isDone" class="w-8 m-0 vs-checkbox-small" @click.stop></vs-checkbox> -->
          <h6 class="technic-title" :class="{ 'line-through': isDone }">
            <span
              v-bind:title="
                'Oluşturulma Tarihi: ' +
                  $moment(serviceItem.createdDate)
                    .locale('tr')
                    .format('DD.MMMM.YYYY')
              "
              >{{
                $moment(serviceItem.createdDate)
                  .locale("tr")
                  .format("DD.MMMM.YYYY")
              }}</span
            >
            <span v-bind:title="serviceItem.saleOrderId">#Id: {{ serviceItem.saleOrderId }}</span>
            <span v-if="serviceItem.price" v-bind:title="serviceItem.saleOrderId">{{ serviceItem.price }}</span>
            <span v-bind:title="serviceItem.customer">{{ trimString(serviceItem.customer, 30) }}</span>
            <span v-bind:title="printProducts(serviceItem.products)">Ürünler</span>
            <span v-bind:title="serviceItem.saleOrderType">{{ trimString(serviceItem.saleOrderType, 30) }}</span>
            <span v-bind:title="'Atanan personel: ' + serviceItem.createdUser">
              Personel:
              {{ serviceItem.createdUser ? trimString(serviceItem.createdUser, 30) : "Personel Bulunamadı" }}
            </span>
          </h6>
        </div>
      </div>

      <div class="vx-col w-full sm:w-2/12 ml-auto flex sm:justify-end sm:flex m-auto">
        <div class="vx-col w-full sm:w-1/2 ml-auto flex sm:justify-end sm:flex m-auto technic-tags sm-list">
          <vs-chip v-if="serviceItem.invoiced > 0">
            <feather-icon title="Faturalandı" class="satirIcon text-success" icon="FileTextIcon"></feather-icon>
          </vs-chip>
          <vs-chip v-if="serviceItem.invoiced == 0">
            <feather-icon title="Fatura kesilecek" class="satirIcon text-warning" icon="FileTextIcon"></feather-icon>
          </vs-chip>
          <vs-chip style="font-size: 7px; white-space: nowrap">
            <feather-icon :title="serviceItem.saleOrderStatus" class="satirIcon" :icon="serviceStatusIcon(serviceItem.saleOrderStatusId)"></feather-icon>
          </vs-chip>
          <vs-chip class="flex items-center" style="font-size: 7px; white-space: nowrap">
            <div>
              <i :title="serviceItem.saleOrderType" style="font-size: 16px" class="vs-icon notranslate icon-scale material-icons">{{ orderTypeList_style(serviceItem.saleOrderTypeId, true) }}</i>
            </div>
          </vs-chip>
        </div>
        <div class="vx-col w-full sm:w-1/2 ml-auto flex sm:justify-end sm:flex m-auto sm-list">
          <feather-icon v-if="true" title="Teklif Gönder" icon="MailIcon" class="cursor-pointer info stroke-current mr-2" @click.stop="openSendEmailPopup"></feather-icon>
          <feather-icon v-if="false" title="Mesaj Ekle" icon="MessageSquareIcon" class="cursor-pointer text-success stroke-current mr-10" @click.stop="openAddMessagePopup"></feather-icon>
          <div class="mr-8" v-if="!displayQuickActions()">&nbsp;</div>
          <feather-icon
            v-if="displayQuickActions() || $store.state.userData.authorizationList.find((f) => f.authorizationId == '13') != null"
            title="Hızlı İşlem Menüsü"
            icon="ExternalLinkIcon"
            class="cursor-pointer text-danger stroke-current"
            @click.stop="openAssignPopup"
          ></feather-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  props: {
    serviceItem: {
      type: Object,
    },
    value: "",
  },
  data() {
    return {
      matchedStyle: {},
      unmatchedStyle: {},
      isDone: false,
      serviceStatus: [],
      orderTypeList: [],
      disabledQuickActions: [],
      serviceStatusSeleciton: "",
    };
  },
  methods: {
    openEmailForm() {
      this.$emit("openEmailPopup", this.serviceItem.saleOrderId);
    },
    printProducts(r) {
      if (r == null) return "yok";
      if (Array.isArray(r)) {
        if (r.length <= 0) return "yok";
        let ret = "";
        for (var i = 0; i < r.length; i++) {
          if (typeof r[i].productName == "string" && r[i].productName.length > 0) {
            r[i] = repository.convertToJSON(r[i], "productName");
            if (r[i].productName && r[i].productName.length == 1) r[i].productName = r[i].productName[0];
          }
          ret += "\n " + r[i].productAmount + " Adet " + r[i].productName;
        }
        return ret.substr(2);
      } else if (!r.productName) return "yok";
      return r.productName;
    },
    displayQuickActions() {
      return !this.disabledQuickActions[this.serviceItem.saleOrderStatusId];
    },
    displayPrompt() {
      this.$emit("showDisplayPrompt", this.serviceItem.saleOrderId);
    },

    openAssignPopup() {
      this.$emit("openAssignPopup", this.serviceItem.saleOrderId);
    },
    openSendEmailPopup() {
      this.$emit("openSendEmailPopup", this.serviceItem);
    },
    openAddMessagePopup() {
      this.$emit("openAddMessagePopup", this.serviceItem.saleOrderId);
    },
    openTransferPopup() {
      this.$emit("openTransferPopup", this.serviceItem.saleOrderId);
    },
    trimString(val, len) {
      if (!val) return "";
      val = val.trim();
      if (val != null && val.length > len) val = val.substr(0, len);
      return val;
    },

    serviceStatusIcon(id) {
      if (!this.serviceStatus || typeof this.serviceStatus !== "object") return "";
      let y = this.serviceStatus[id];
      if (!y || !y.other || !y.other.icon) return "";
      return y.other.icon;
    },
    orderTypeList_style(id, color) {
      if (!this.orderTypeList) return "";
      let y = this.orderTypeList[id];
      if (!y || !y.classList) return "";
      return color ? y.style.split("|")[0] : y.classList;
    },
    setClasses(a, b) {
      return navigator.isMobile ? a : b;
    },
  },
  created() {
    this.disabledQuickActions[4] = true;
    this.disabledQuickActions[8] = true;
    this.disabledQuickActions[97] = true;
    this.disabledQuickActions[99] = true;
    this.disabledQuickActions[100] = true;
    if (localStorage["salesStatusList"]) {
      let ssl = repository.convertToJSON(localStorage["salesStatusList"], "other");
      if (Array.isArray(ssl)) {
        //servicestatus
        for (let i = 0; i < ssl.length; i++) {
          this.serviceStatus[ssl[i].id] = Object.assign({}, ssl[i]);
        }
      }
    }
    if (localStorage["salesOrderTypeList"]) {
      let otl = repository.convertToJSON(localStorage["salesOrderTypeList"], "other");
      if (Array.isArray(otl)) {
        for (let i = 0; i < otl.length; i++) {
          this.orderTypeList[otl[i].id] = Object.assign({}, otl[i]);
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.tekSatir {
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: hidden;
  font-size: 8px;
}
.mobSatir {
  padding: 4px;
  white-space: normal;
  overflow-x: visible;
}
@media screen and (max-width: 575px) {
  .sm-list {
    display: flex !important;
    margin-left: 10px !important;
    margin-right: 0px !important;
    width: auto !important;
    padding: 0px !important;
  }
}
</style>
